export default class Alphanumeric {

  constructor() {
    this.restrict = 'EA';
    this.require = 'ngModel';
  }

  link(scope, element, attrs, ngModel) {

    function fromUser(text) {
        if (text) {
            var transformedInput = text.replace(/[^0-9a-zA-Z\s]/g, '');

            if (transformedInput !== text) {
                ngModel.$setViewValue(transformedInput);
                ngModel.$render();
            }
            return transformedInput;
        }
        return undefined;
    }            
    ngModel.$parsers.push(fromUser);
  }

  static create() {
    return new Alphanumeric();
  }
}


// WEBPACK FOOTER //
// ./app/js/directives/alphanumeric.js